import React from 'react';
import classNames from 'classnames';

export const Card = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={classNames('card', className)} {...props}>
    {children}
  </div>
));

export const CardBody = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={classNames('card-body', className)} {...props}>
    {children}
  </div>
));

export const CardFooter = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={classNames('card-footer', className)} {...props}>
    {children}
  </div>
));

export const CardTitle = React.forwardRef(({ className, children, tag: Tag = 'h5', ...props }, ref) => (
  <Tag ref={ref} className={classNames('card-title', className)} {...props}>
    {children}
  </Tag>
));
